<template>
  <div>
  <div v-if="sdkShow" style="width: 80%;">

    <pdf :src="pdfSrc" :page="pageNumber" :page-width="pageWidth" @num-pages="setNumPages" />
    <div>
      <button @click="prevPage" :disabled="pageNumber <= 1">上一页</button>
      <span>{{ pageNumber }} / {{ numPages }}</span>
      <button @click="nextPage" :disabled="pageNumber >= numPages">下一页</button>
    </div>
  </div>

    <div v-if="sdkShow1" style="width: 80%;">

      <pdf :src="pdfSrc1" :page="pageNumber" :page-width="pageWidth" @num-pages="setNumPages" />
      <div>
        <button @click="prevPage" :disabled="pageNumber <= 1">上一页</button>
        <span>{{ pageNumber }} / {{ numPages }}</span>
        <button @click="nextPage" :disabled="pageNumber >= numPages">下一页</button>
      </div>
    </div>

    <div v-if="sdkShow2" style="width: 80%;">

      <pdf :src="pdfSrc2" :page="pageNumber" :page-width="pageWidth" @num-pages="setNumPages" />
      <div>
        <button @click="prevPage" :disabled="pageNumber <= 1">上一页</button>
        <span>{{ pageNumber }} / {{ numPages }}</span>
        <button @click="nextPage" :disabled="pageNumber >= numPages">下一页</button>
      </div>
    </div>
  </div>
</template>

<script>
import { pdfjs } from 'vue-pdf';
import VuePdf from 'vue-pdf';
import pdfSrc from '@/assets/pdf/picSdk.pdf';
import pdfSrc1 from '@/assets/pdf/medicalImageSdk.pdf';
import pdfSrc2 from '@/assets/pdf/text&logSdk.pdf';

export default {
  components: {
    pdf: VuePdf,
  },
  data() {
    return {
      sdkShow:false,
      sdkShow1:false,
      sdkShow2:false,
      sdkIndex:0,
      pdfSrc: pdfSrc, // 替换为你的 PDF 文件路径
      pdfSrc1: pdfSrc1,
      pdfSrc2: pdfSrc2,
      pageNumber: 1,
      numPages: 0,
      pageWidth: 500, // 设置页面宽度，可以根据需要调整
    };
  },
  mounted() {
    this.sdkIndex =parseInt(this.$route.params.yourParameterName) ;

if(this.sdkIndex===1){
  this.sdkShow=true
}
    if(this.sdkIndex===2){
      this.sdkShow1=true
    }
    if(this.sdkIndex===3){
      this.sdkShow2=true
    }
    if(this.sdkIndex===4){
      this.sdkShow2=true
    }

    console.log( this.sdkIndex)

  },
  methods: {
    setNumPages(numPages) {
      this.numPages = numPages;
    },
    prevPage() {
      if (this.pageNumber > 1) {
        this.pageNumber -= 1;
      }
    },
    nextPage() {
      if (this.pageNumber < this.numPages) {
        this.pageNumber += 1;
      }
    },
  },
};
</script>
